import axios from "axios";

const lmsApiService = axios.create({
  baseURL: process.env.SMART_LMS_API_URL,
});

lmsApiService.interceptors.request.use((config) => {
  if (config.data && config.data instanceof FormData) {
    config.data.append("moodlewsrestformat", "json");
    config.data.append("wstoken", process.env.SMART_LMS_API_TOKEN!);
  }

  if (!config.data) {
    config.data.append("moodlewsrestformat", "json");
    config.data.append("wstoken", process.env.SMART_LMS_API_TOKEN!);
  }

  // You can modify the request config here if needed
  return config;
});

export default lmsApiService;
